/* eslint-disable bsky-internal/avoid-unwrapped-text */
import {useAgent} from '#/state/session'
import {useIsMobileWeb} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import {BodyText, Heading} from '#/wsocial/components/primitives'
import {BackButton, PageShell, SupportFooter} from './primitives'
import {QrSessionBlock} from './QrSessionBlock'

export function StepCreateWid({
  onBack,
  onSkip,
  onNext,
}: {
  onBack: () => void
  onSkip?: () => void
  onNext: () => void
}) {
  const agent = useAgent()
  const isMobileWeb = useIsMobileWeb()

  return (
    <PageShell>
      <div className="SignUpQrCenter">
        <QrSessionBlock
          size={300}
          queryKey="create-wid"
          initFn={(signal, prevServiceId, prevSessionId) =>
            agent.quicklogin.linkWid({
              signal,
              ...(prevServiceId && {serviceId: prevServiceId}),
              ...(prevSessionId && {sessionId: prevSessionId}),
            })
          }
          statusFn={(params, signal) =>
            agent.quicklogin.status(params, {signal})
          }
          autoRefresh
        />
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          padding: '24px 16px',
          textAlign: 'center',
        }}>
        <Heading>Verify your account</Heading>
        <BodyText>
          Scan the code to verify your account. The W Identity setup must be
          complete before you scan.
        </BodyText>
      </div>

      {isMobileWeb ? (
        <div
          style={{
            padding: '16px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}>
          <Button
            label="Continue"
            color="primary"
            size="large"
            onPress={onNext}
            style={{width: '100%'}}>
            <ButtonText>Continue</ButtonText>
          </Button>
          {onSkip && (
            <Button
              label="Remind me later"
              color="secondary"
              size="large"
              onPress={onSkip}
              style={{width: '100%'}}>
              <ButtonText>Remind me later</ButtonText>
            </Button>
          )}
          <Button
            label="Go back"
            color="secondary"
            size="large"
            onPress={onBack}
            style={{width: '100%'}}>
            <ButtonText>Back</ButtonText>
          </Button>
        </div>
      ) : (
        <div
          style={{
            padding: '16px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}>
          <BackButton onPress={onBack} />
          <div
            style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 10,
            }}>
            {onSkip && (
              <Button
                label="Remind me later"
                color="secondary"
                size="large"
                onPress={onSkip}>
                <ButtonText>Remind me later</ButtonText>
              </Button>
            )}
            <Button
              label="Continue"
              color="primary"
              size="large"
              onPress={onNext}>
              <ButtonText>Continue</ButtonText>
            </Button>
          </div>
        </div>
      )}

      <SupportFooter />
    </PageShell>
  )
}
